import { render } from "./VUEFrameComponenteGraficoAccSupSoglie.vue?vue&type=template&id=6fdffe56"
import script from "./VUEFrameComponenteGraficoAccSupSoglie.vue?vue&type=script&lang=js"
export * from "./VUEFrameComponenteGraficoAccSupSoglie.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__